import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'
import Login from '../views/Login/Login.vue'
import Register from '../views/Register/Register.vue'
import ForgetPsd from "../views/ForgetPsd"
import Mail from "../views/Mail/Mail.vue"
import MailType1 from "../views/Mail/MailType/Type1"
import MailType2 from "../views/Mail/MailType/Type2"
import MailType3 from "../views/Mail/MailType/Type3"
import MailType4 from "../views/Mail/MailType/Type4"
import Purchasing from "../views/Mail/Purchasing.vue"
import PurchasingType1 from "../views/Mail/Purchasing/Type1"
import Steps from '../views/Mail/Steps/Steps'
import Step2 from '../views/Mail/Steps/Step2'
import Step3 from '../views/Mail/Steps/Step3'
import Step4 from '../views/Mail/Steps/Step4'
import Contacts from '../views/My/Contacts'
import Order from '../views/My/Order'
import MailTeaching from "../views/MailTeaching/MailTeaching.vue"
import Settings from "../views/My/Settings.vue"
import {Message} from "element-ui"
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/mail',
    name: 'Mail',
    component: Mail,
    redirect:'/mail/type1',
    children:[
      {
        path: '/mail/Type1',
        name: 'MailType1',
        component: MailType1
      },
      {
        path: '/mail/Type2',
        name: 'MailType1',
        component: MailType2
      },
      {
        path: '/mail/Type3',
        name: 'MailType1',
        component: MailType3
      },
      {
        path: '/mail/Type4',
        name: 'Register',
        component: MailType4
      },
    ]
  },
  {
    path: '/purchasing',
    name: 'Purchasing',
    component: Purchasing,
    redirect:'/purchasing/type1',
    children:[
      {
        path: '/purchasing/Type1',
        name: 'PurchasingType1',
        component: PurchasingType1
      }
    ]
  },
  {
    path: '/steps',
    name: 'Steps',
    component: Steps,
    redirect:'/steps/step3',
    children:[
      {
        path: '/steps/step2',
        name: 'Step2',
        component: Step2
      },
      {
        path: '/steps/step3',
        name: 'Step3',
        component: Step3
      },
      {
        path: '/steps/step4',
        name: 'Step4',
        component: Step4
      },
    ]
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: Contacts
  },
  {
    path: '/order/:tabIndex',
    name: 'order',
    component: Order
  },
  {
    path: '/mailTeaching/:tabIndex',
    name: 'mailTeaching',
    component: MailTeaching
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/ForgetPsd',
    name: 'ForgetPsd',
    component: ForgetPsd
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由首位
router.beforeEach((to,from,next)=>{

    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0

  // 路由白名单
  if(to.name == "Home" || to.name == "Login" || to.name == "Register" || to.name == "ForgetPsd" || to.name == "PurchasingType1"){
    next();
  }else if(!window.sessionStorage.getItem("token")){
    // 未登录
    Message("請登入後再操作")
    return next("/login")
  }else{
    next();
  }

})


export default router
